import { lazy } from "react";
import type { ComponentType } from "react";

type ComponentModule = { default: ComponentType<any> };

export function lazyWithRetry(factory: () => Promise<ComponentModule>) {
  return lazy(() => {
    const key = `chunk_reload_${window.location.pathname}`;
    return factory()
      .then((mod) => {
        sessionStorage.removeItem(key);
        return mod;
      })
      .catch(() => {
        if (!sessionStorage.getItem(key)) {
          sessionStorage.setItem(key, "1");
          window.location.reload();
        }
        return new Promise<ComponentModule>(() => {});
      });
  });
}
